var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, makeObservable } from 'mobx';
import { Actor } from '../../../classes/actor/Actor';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { ChoiceOptionActions } from './modules/ChoiceOptionActions';
import { ChoiceOptionUI } from './modules/ChoiceOptionUI';
import { editable } from '../../../utils/mobx/decorators/editable';
import { deserialize } from '../../../utils/serializr/core/deserialize';
import { ChoiceOptionAudio } from './modules/ChoiceOptionAudio';
import { ChoiceSelection } from '../ChoiceSelection/ChoiceSelection';
export class ChoiceOption extends Actor {
    type = 'option';
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get question() {
        return this.parent;
    }
    get optionActions() {
        return new ChoiceOptionActions(this);
    }
    get optionUI() {
        return new ChoiceOptionUI(this);
    }
    get optionAudio() {
        return new ChoiceOptionAudio(this);
    }
    shouldBeSelected_raw = false;
    isSelected_raw = false;
    get shouldBeSelected() {
        return this.shouldBeSelected_raw;
    }
    set shouldBeSelected(isTrue) {
        this.shouldBeSelected_raw = isTrue;
    }
    get isSelected() {
        return this.isSelected_raw;
    }
    set isSelected(isTrue) {
        this.isSelected_raw = isTrue;
    }
    get isOptionHovering() {
        return this.actorInteract.isActorHovering;
    }
    get isPreselecting() {
        return this.question.preselectingOption === this;
    }
    get isKeyboardOption() {
        return this.question.choiceKeyboardSelect.keyboardOption === this;
    }
    get isOptionActive() {
        return this.actorInteract.isActorActive;
    }
    get isNotSelected() {
        return this.isSelected === false;
    }
    get isOpenToBeSelected() {
        return this.isSelected === false && this.shouldBeSelected === true;
    }
    get isCorrectlySelected() {
        return this.isSelected === true && this.shouldBeSelected === true;
    }
    get isWronglySelected() {
        return this.isSelected === true && this.shouldBeSelected === false;
    }
    get optionIndex() {
        return this.question.options.indexOf(this);
    }
    get optionNumber() {
        return this.optionIndex + 1;
    }
    get shuffledOptionIndex() {
        return this.question.shuffledOptions.indexOf(this);
    }
    get shuffledOptionNumber() {
        return this.shuffledOptionIndex + 1;
    }
    get itemNumber() {
        return this.shuffledOptionNumber;
    }
    get commentAspectToShow() {
        if (this.isSelected) {
            if (this.isCorrectlySelected && this.ownAspect.commentCorrect.aspectContent.regional.hasContent) {
                return this.ownAspect.commentCorrect;
            }
            if (this.isWronglySelected && this.ownAspect.commentWrong.aspectContent.regional.hasContent) {
                return this.ownAspect.commentWrong;
            }
            if (this.ownAspect.comment.aspectContent.regional.hasContent) {
                return this.ownAspect.comment;
            }
        }
        return null;
    }
    get optionPosition() {
        return {
            left: this.inner.aspectMount.measureToWindowIncludingTransform.aspectLeftInPixel,
            top: this.inner.aspectMount.measureToWindowIncludingTransform.aspectTopInPixel,
        };
    }
    selectOption({ event }) {
        const selection = new ChoiceSelection({ event, selectedOption: this });
        this.question.selections.unshift(selection);
        if (selection.isFailedAttempt) {
            return;
        }
        this.isSelected = true;
        if (this.isWronglySelected) {
            this.question.answeringStepMistake.trackMistake();
        }
        if (this.isCorrectlySelected) {
            this.question.answeringStepCorrect.trackCorrect();
        }
    }
    static fromSerialized(json = {}) {
        return deserialize(ChoiceOption, json);
    }
    static get serializeInfo() {
        return {
            extends: Actor.serializeInfo,
            props: {
                shouldBeSelected: true,
            },
        };
    }
    static get stripInfo() {
        return {
            extends: Actor.stripInfo,
            props: {
                shouldBeSelected: true,
            },
        };
    }
}
__decorate([
    memoize
], ChoiceOption.prototype, "optionActions", null);
__decorate([
    memoize
], ChoiceOption.prototype, "optionUI", null);
__decorate([
    memoize
], ChoiceOption.prototype, "optionAudio", null);
__decorate([
    editable()
], ChoiceOption.prototype, "shouldBeSelected_raw", void 0);
__decorate([
    observable
], ChoiceOption.prototype, "isSelected_raw", void 0);
__decorate([
    action.bound
], ChoiceOption.prototype, "selectOption", null);
__decorate([
    memoize
], ChoiceOption, "serializeInfo", null);
__decorate([
    memoize
], ChoiceOption, "stripInfo", null);
